__turbopack_context__.v({
  "card": "ProducerMapCard-module-scss-module__-e6Giq__card",
  "location": "ProducerMapCard-module-scss-module__-e6Giq__location",
  "percentage": "ProducerMapCard-module-scss-module__-e6Giq__percentage",
  "producer-location-container": "ProducerMapCard-module-scss-module__-e6Giq__producer-location-container",
});
